module.exports = __webpack_public_path__ + "img/svg/user-add.451fc39da380401d54db2c96b291e7d6.svg";